import React from 'react';
import { Tag } from 'antd';
import { Colors } from '@cognite/cogs.js';

export const AlphaBadge = ({ text }: { text?: string }) => {
  return <Tag color={Colors.danger.hex()}>{text || 'ALPHA'}</Tag>;
};
